import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import styled from "styled-components";

import { enWebPage } from "../../../lib/ConstCommand";

import { subscribe } from "../../../lib/MediaSoupClient";
import { connectLiveForSmartTV } from "../../../lib/RabbitmqClient";
import { addMediaError, videoErrorCodeToString } from "../../../lib/MediaErrorLog"; // 20260904 선생님 영상 재생 실패를 누적 오류 로그에 기록 ... by claude

// import ConnectImg from "../../../images/connect.png";
// import AndroidConnectImg from "../../../images/android_connect.png";

// const ConnectImgComp = styled.img`
//     width : '100px';
//     height : '100px;
// `;

// const VideoComp = ConnectImgComp.withComponent("video");

const SmartTVMediaSoupRcv = forwardRef(({ userSeq, isModalOpened, currentPageType, performLiveInfo, performLiveStatusInfo, smartTVBindInfo, onSwitchView }, ref) => {
    const { t } = useTranslation();
    const history = useHistory();

    const [teacherInfo, setTeacherInfo] = useState(performLiveInfo && performLiveInfo.teacher_info ?
        performLiveInfo.teacher_info : { userSeq: -1, userNickname: "", userGateWay: "" });

    const [lClassName, setClassName] = useState("main-view");
    const [lDisplay, setDisplay] = useState("block");
    const [lWidth, setWidth] = useState("100%");
    const [lHeight, setHeight] = useState("100%");
    const [isMain, setIsMain] = useState(true);
    // const [lWidth, setWidth] = useState("100%");
    // const [lZIndexValue, setZIndexValue] = useState("unset");
    // const [lHeight, setHeight] = useState("100%");
    // const [lLeftValue, setLeftValue] = useState("2px");
    // const [lBottomValue, setBottomValue] = useState("2px");
    // const [lWidth, setWidth] = useState("240px");
    // const [lHeight, setHeight] = useState("135px");
    // const [lZIndexValue, setZIndexValue] = useState("5");

    const videoEl = useRef(null);
    const audioEl = useRef(null);
    const micEl = useRef(null);

    // ✅ alert가 이미 발생했는지 추적하는 플래그 추가 ... by hjkim 20260413
    const isAlertShownRef = useRef(false);

    const liveMediaSoupHandler = useCallback(() => {
        if (!isModalOpened) {
            if (teacherInfo.userSeq > -1 && performLiveInfo.liveSeq > -1) {
                if (performLiveInfo.liveStatus === "Y") {
                    if (performLiveStatusInfo.connectStatus === "disable") {
                        if (smartTVBindInfo.bindKeyArr.length > 0 && smartTVBindInfo.startSeqOfSmartTV > -1 && smartTVBindInfo.serverGateWay && smartTVBindInfo.serverGateWay !== "") {
                            connectLiveForSmartTV(smartTVBindInfo.bindKeyArr, smartTVBindInfo.startSeqOfSmartTV, smartTVBindInfo.serverGateWay);
                        } else {
                            console.log("liveMediaSoupHandler - smartTVBindInfo.bindKeyArr => ", smartTVBindInfo.bindKeyArr);
                            console.log("liveMediaSoupHandler - smartTVBindInfo.startSeqOfSmartTV => ", smartTVBindInfo.startSeqOfSmartTV);
                            console.log("liveMediaSoupHandler - smartTVBindInfo.serverGateWay => ", smartTVBindInfo.serverGateWay);
                        }
                    } else {
                        console.log(`liveMediaSoupHandler - connectStatus[${performLiveStatusInfo.connectStatus}]`);
                    }
                } else { // performLiveInfo.liveStatus === "N" case
                    console.log(`userSeq[${teacherInfo.userSeq}], liveSeq[${performLiveInfo.liveSeq}], liveStatus[${performLiveInfo.liveStatus}], connectStatus[${performLiveStatusInfo.connectStatus}]`);
                    console.log("smartTVBindInfo.bindKeyArr => ", smartTVBindInfo.bindKeyArr);
                    console.log("smartTVBindInfo.startSeqOfSmartTV => ", smartTVBindInfo.startSeqOfSmartTV);
                    console.log("smartTVBindInfo.serverGateWay => ", smartTVBindInfo.serverGateWay);
                    if (performLiveStatusInfo.connectStatus !== "disable") {
                        // ✅ 이미 alert를 띄웠다면 중복 실행 차단
                        if (isAlertShownRef.current) {
                            console.log("liveMediaSoupHandler - alert already shown, skip.");
                            return;
                        }

                        // ✅ 플래그를 true로 설정해서 이후 재실행 시 차단
                        isAlertShownRef.current = true;

                        alert(t("클래스_종료_안내_문구_3", { ns: "live" }));

                        if (currentPageType === enWebPage.SmartTV) {
                            window.location.replace(`/smarttv-login/${performLiveInfo.liveSeq}`);
                        } else { // GroupSmartTV
                            window.location.replace(`/group-smarttv-login/${performLiveInfo.liveSeq}`);
                        }
                    } else {
                        console.log("liveMediaSoupHandler - 이런 경우가 있나요..? ... connectStatus => ", performLiveStatusInfo.connectStatus);
                    }
                }
            } else {
                console.log(`liveMediaSoupHandler - userSeq[${teacherInfo.userSeq}], liveSeq[${performLiveInfo.liveSeq}]`);
            }
        } else {
            console.log(`liveMediaSoupHandler - isModalOpened[${isModalOpened}]`);
        }
    }, [t, isModalOpened, teacherInfo.userSeq, performLiveInfo.liveSeq, performLiveInfo.liveStatus, performLiveStatusInfo.connectStatus, smartTVBindInfo.bindKeyArr, smartTVBindInfo.startSeqOfSmartTV, smartTVBindInfo.serverGateWay, currentPageType/* , history */]);

    useImperativeHandle(ref, () => ({
        updateMediaView: (value) => updateView(value),
        getDomNode: ()=> videoEl.current.parentNode,
    }));

    useEffect(() => {
        liveMediaSoupHandler();
    }, [liveMediaSoupHandler]);

    useEffect(() => {
        if (performLiveStatusInfo.isConnect) {
            console.log("performLiveStatusInfo.isConnect => ", performLiveStatusInfo.isConnect);
            subscribe(videoEl.current, audioEl.current, micEl.current);
        } else {
            console.log("performLiveStatusInfo.isConnect => ", performLiveStatusInfo.isConnect);
            if (videoEl.current) {
                videoEl.current.pause();
                videoEl.current.currentTime = 0;
                videoEl.current.poster = "/images/connect.png";
            } else {
                console.log("이런 경우는 뭘 해야 하는가..?");
            }
        }
    }, [performLiveStatusInfo.isConnect]);

    useEffect(() => {
        if (performLiveInfo.teacher_info) {
            setTeacherInfo({
                userSeq: performLiveInfo.teacher_info.userSeq,
                userNickname: performLiveInfo.teacher_info.userNickname,
                userGateWay: performLiveInfo.teacher_info.userGateWay
            });
        }
    }, [performLiveInfo.teacher_info]);

    // 20260904 선생님 영상 재생(디코딩) 실패를 감지해 누적 오류 로그에 기록한다. ... by claude
    const teacherInfoRef = useRef(teacherInfo);
    useEffect(() => { teacherInfoRef.current = teacherInfo; }, [teacherInfo]);

    useEffect(() => {
        const videoNode = videoEl.current;
        if (!videoNode) return undefined;

        const onVideoError = () => {
            const mediaError = videoNode.error;
            addMediaError({
                roomKind: "live",
                mediaKind: "video",
                prodUserSeq: teacherInfoRef.current.userSeq,
                errorCode: videoErrorCodeToString(mediaError && mediaError.code)
            });
        };

        videoNode.addEventListener("error", onVideoError);
        return () => videoNode.removeEventListener("error", onVideoError);
    }, []);

    const updateView = ({ className, width, height, display, zIndex, isImageViewToggle, isMultiViewToggle }) => {
        // let msg = `updateView - className[${className}], lWidth[${lWidth.current}], width[${width}]`;
        // msg += `, display[${display}], zIndex[${zIndex}], isImageViewToggle[${isImageViewToggle}], isMultiViewToggle[${isMultiViewToggle}]`;
        // console.log(msg);
        // if (width) setWidth(width);
        if (width) {
            setWidth(width);
            setHeight(height);
        }
        if (isMain !== undefined) {
            setIsMain(isMain);
        }
        if (className) setClassName(className);
        // console.log(`lWidth[${lWidth.current}], width[${width}]`);
        // console.log(`lDisplay[${lDisplay}], display[${display}]`);
        if (width !== "100%") {
            if (display) setDisplay(display);
            setIsMain(false);
        } else {
            if (width === "100%") {
                setDisplay("block");
                setIsMain(true);
                // if (zIndex) setZIndexValue(zIndex);
            }
        }
    }

    const onClickView = () => {
        if (lWidth === "100%") {
            onSwitchView({ kind: "image_full_mode", idx:-1, userSeq });
        } else {
            onSwitchView({ kind: "media_full_mode", idx:-1, userSeq });
        }
    }

    return (
        <div
            ref={ref}
            className={isMain?"mediasoup-comp-container main-view":""}
            style={{ position:isMain?"fixed":"relative", display: `${lDisplay}`, width:`${lWidth}`, height:`${lHeight==="100%"?"calc(100vh - 50px)":lHeight}` , margin:isMain?"0px":"0px 5px" }}
            onClick={onClickView}
        >
            <video key={"mediasoup-video-comp-" + userSeq} id={"mediasoup-video-comp-" + userSeq} ref={videoEl} className="mediasoup-comp teacher" poster="/images/connect.png" playsInline autoPlay muted />
            <span className="mediasoup-comp teacher">{t("진행자_화면", { ns: "live" })}</span>
            <audio key={"mediasoup-audio-comp-" + userSeq} id={"mediasoup-audio-comp-" + userSeq} ref={audioEl} style={{ display: 'none' }} autoPlay />
            <audio key={"mediasoup-mic-comp-" + userSeq} id={"mediasoup-mic-comp-" + userSeq} ref={micEl} style={{ display: 'none' }} />
        </div>
    );
});

export default SmartTVMediaSoupRcv;